import { useState } from 'react';
import AutocompleteInput, {
  Option,
} from '@/components/inputs/AutocompleteInput';
import { useUsersOptions } from '../../../hooks';
import { SelectInput, GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import {
  Search as SearchIcon,
  DeleteForever as TrashIcon,
} from '@mui/icons-material';
import { useRequestOptions, RequestsFilter } from '../hooks';

interface SearchBarProps {
  initialFilter: RequestsFilter;
  filter: RequestsFilter;
  search: (updatedFilter: RequestsFilter) => void;
}

const SearchBar = ({ initialFilter, filter, search }: SearchBarProps) => {
  const [localFilter, setLocalFilter] = useState<RequestsFilter>(filter);
  const [userInput, setUserInput] = useState('');
  const [selectedUser, setSelectedUser] = useState<Option | null>(null);
  const [selectedType, setSelectedType] = useState<Option | null>(null);

  const { userOptions, isUsersLoading } = useUsersOptions({
    search: userInput,
  });

  const resetFilter = () => {
    setLocalFilter(initialFilter);
    setUserInput('');
    setSelectedUser(null);
    setSelectedType(null);
    search(initialFilter);
  };

  const handleSearch = () => {
    search(localFilter);
  };

  const handleUpdateFilter = (updatedFilter: Partial<RequestsFilter>) => {
    setLocalFilter((prev) => ({ ...prev, ...updatedFilter }));
  };

  const { requestStatusOptions, requestTypeOptions } = useRequestOptions();

  const handleUserSelect = (option: Option | null) => {
    setSelectedUser(option);
    handleUpdateFilter({
      userId: option?.data?.id ? [option.data.id] : [],
    });
  };

  const handleTypeSelect = (option: Option | null) => {
    setSelectedType(option);
    handleUpdateFilter({
      assetTypeId: option?.data?.id ? [option.data.id] : [],
    });
  };

  return (
    <div className='w-full flex flex-col justify-center gap-5 p-5 bg-white rounded-sm shadow-xl'>
      <div className='flex gap-5 justify-end'>
        <SelectInput
          name='request-status-filter'
          placeholder='Filtrar por estado'
          options={requestStatusOptions}
          value={localFilter.statuses?.[0] || ''}
          onChange={(statusValue) =>
            setLocalFilter({
              ...localFilter,
              statuses: [statusValue.toString()],
            })
          }
        />
        <AutocompleteInput
          name='type-requests-search'
          placeholder='Filtrar por tipo'
          value={selectedType}
          onChange={handleTypeSelect}
          onInputChange={() => {}}
          options={requestTypeOptions.map(type => ({
            label: type.label,
            data: { id: type.value }
          }))}
          required={false}
        />
        <AutocompleteInput
          name='user-requests-search'
          placeholder='Buscar usuario'
          value={selectedUser}
          onChange={handleUserSelect}
          onInputChange={setUserInput}
          options={userOptions}
          required={false}
          disabled={isUsersLoading}
        />
      </div>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={resetFilter}
        >
          <TrashIcon color='primary' />
          Limpiar
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={handleSearch}
        >
          <SearchIcon color='primary' />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
};

export default SearchBar;
